import { Component, ViewChild, HostListener, ElementRef } from "@angular/core";
import { Agent, Role, Status, Category } from "../../models";
import { Filter, HttpService } from "../../services";
import { BsModalComponent } from "ng2-bs3-modal/ng2-bs3-modal";
//import * as _ from 'underscore';
import { PagerService } from "../../services/index";
import { StringUtility } from "../../util/string.utility";
import { AgentUtility } from "../../util/agent.utility";
import { Router } from "@angular/router";
import { AgentsService } from "../../services/agents.service";
import { ResponseApi } from "../../services/response/response";

@Component({
    moduleId: module.id,
    selector: 'agents',
    templateUrl: 'agents.component.html',
    styles: ['>>> .modal-xl { width: 590px; heigth: 2000px;}',
        '.agnet-load-screen{ position: absolute; left: 45%; top: 45%; z-index:5; }',
        '.agnet-load-screen_container { position: absolute; width: 100%; height: 100%; background-color: rgba(223, 223, 223, 0.3); z-index:5;}'],
    providers: [AgentsService, PagerService]
})
export class AgentsComponent {
    @ViewChild('editAgentsModal',{static: false}) editAgentsModal: BsModalComponent;
    @ViewChild('agentsRolesModal',{static: false}) agentsRolesModal: BsModalComponent;
    filterValues: Filter = new Filter();
    idRole: number;
    agents: Agent[] = [];
    roles: Role[] = [];
    statuses: Status[] = [];
    categories: Category[] = [];

    selectedAgentId: number;
    showLoadScreen: boolean = false;

    pager: any = {};
    pagedItems: any[];
    pageSize: number = 20;
    totalItems: number;

    selectedAgents: number[] = [];

    constructor(private agentsService: AgentsService, private pagerService: PagerService, private eRef: ElementRef, private router: Router) {
        this.agentsService.onStart = () => this.showLoadScreen = true;
        this.agentsService.onEnd = () => this.showLoadScreen = false;
    }

    @HostListener('document:click', ['$event'])
    clickout(event) {
        if (this.eRef.nativeElement.contains(event.target)) {

        } else {
            if (event.srcElement.pathname == '/agents') {
                this.filterValues = new Filter();
                this.ngOnInit();
            }

        }
    }

    setAgentLK(id) {
        this.agentsService.getAgent(id).subscribe((data: ResponseApi) => {
            this.agentsService.getV_Agent(id).subscribe((v_agent) => {
                let agent = data.data;
                agent['v_agent'] = v_agent.data;
                AgentUtility.setOtherUserInfo(agent);
                this.router.navigateByUrl('/');
            });
        });
    }

    ngOnInit() {
        this.agentsService.getStatusesAllList().subscribe((data) => {
            this.statuses = data.data;
        });
        this.agentsService.getCategories().subscribe((data) => {
            this.categories = data.data;
        });
        this.agentsService.getAgents().subscribe((data) => {
            this.agents = data.data;
            this.totalItems = data.countAll;
            this.setPage(1);

            // for (let agent of this.agents)
            //     for (let role of this.roles) {
            //         if (agent.roleId == role.Id)
            //             agent.roleName = role.Title;
            //     }
            this.agentsService.getRoles().subscribe((data) => {
                this.roles = [];
                this.roles.push(new Role(-1, ''));
                this.roles.push(...data.data);

                this.addRoles();
            });
        });
    }

    visibleChange(): boolean {
        return this.selectedAgents.length > 0;
    }

    select(id: number) {
        if (!this.isChecked(id))
            this.selectedAgents.push(id);
        else {
            var index = this.selectedAgents.indexOf(id);
            this.selectedAgents.splice(index, 1);
        }


    }

    selectAll() {

        if (this.selectedAgents.length != this.agents.length) {
            this.selectedAgents = [];
            this.agents.forEach(element => {
                this.selectedAgents.push(element.Id);
            });
        } else {
            this.selectedAgents = [];
        }

    }

    isChecked(id: number): boolean {
        return this.selectedAgents.indexOf(id) != -1;
    }

    changeRoles() {
        this.agentsService.changeMultiRole(this.idRole, this.selectedAgents).subscribe((r) => {
            //alert(r.json().message);
            this.filter();
            this.agentsRolesModal.close();
            this.selectedAgents = [];
        });
    }

    filter() {
        this.filterValues.page = 1;
        this.agentsService.getAgentsByFilterViews(this.filterValues).subscribe((data) => {
            this.agents = data.data;
            this.totalItems = data.countAll;
            this.setPage(1);
            this.addRoles();
        });
    }

    clear() {
        this.filterValues = new Filter();
        this.ngOnInit();
    }

    addRoles() {
        for (let agent of this.agents) {
            let findRole = this.roles.find((role) => role.Id == agent.RoleId);
            if (findRole != null) {
                agent.roleName = findRole.Title;
            }
        }

        // for (let role of this.roles) {
        //     if (agent.roleId == role.Id)
        //         agent.roleName = role.Title;
        // }
    }

    open(agentId?: number) {
        if (agentId != undefined) {
            this.selectedAgentId = agentId;
            this.editAgentsModal.open();
        }
    }

    add() {
        this.selectedAgentId = undefined;
        this.editAgentsModal.open();
    }

    close() {
        this.selectedAgentId = undefined;
        this.editAgentsModal.close();
    }

    setPage(page: number, needRequest: boolean = false) {
        this.pager = this.pagerService.getPager(this.totalItems, page, this.pageSize);
        if (page < 1 || page > this.pager.totalPages) {
            return;
        }
        if (needRequest) {
            this.filterValues.page = page;
            this.agentsService.getAgentsByFilterViews(this.filterValues).subscribe((data) => {
                this.agents = data.data;
                this.totalItems = data.countAll;
                this.addRoles();
            });
        }
    }

    getAgentStatus(status: number): string {
        switch (status) {
            case 1:
                return 'Активен';
            case 2:
                return 'Неактивен';
            case 3:
                return 'Заблокирован';
        }
    }

    getPagerView(): boolean {
        //
        return this.pager.pages && this.pager.pages.length && this.pager.totalItems > this.pageSize;
    }

    filterPhoneView(str) {
        return StringUtility.PhoneMask(str);
    }
}